import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";

const input =
  "w-full bg-[#050505] px-4 py-3 text-sm text-white outline-none ring-1 ring-zinc-800 transition-shadow focus:ring-[#00ffcc]";
const label = "mb-2 block text-[10px] uppercase tracking-[0.25em] text-zinc-500";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    setMessage("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message || "If that email exists, we sent a link");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="mx-auto max-w-md px-5 py-20 lg:py-28">
      <h1 className="font-display text-3xl tracking-tighter">Forgot password</h1>
      <p className="mt-3 text-xs text-zinc-500">
        Enter the email on your account. If it exists, we will send a one-time reset link that expires in
        10 minutes.
      </p>
      <form onSubmit={submit} className="mt-10 space-y-6 border border-[#1f1f1f] bg-[#0a0a0a] p-6">
        <div>
          <label className={label}>Email</label>
          <input
            data-testid="forgot-password-email"
            className={input}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </div>
        {error && (
          <p
            data-testid="forgot-password-error"
            className="border border-[#ff3b30] bg-[#ff3b30]/10 p-3 text-xs text-[#ff3b30]"
          >
            {error}
          </p>
        )}
        {message && (
          <p
            data-testid="forgot-password-success"
            className="border border-[#00ffcc]/40 bg-[#00ffcc]/10 p-3 text-xs text-[#00ffcc]"
          >
            {message}
          </p>
        )}
        <button
          data-testid="forgot-password-submit"
          disabled={busy}
          className="w-full border border-[#00ffcc] py-3 text-[11px] uppercase tracking-[0.3em] text-[#00ffcc] transition-colors hover:bg-[#00ffcc] hover:text-black disabled:opacity-50"
        >
          {busy ? "Sending…" : "Send reset link"}
        </button>
        <p className="text-xs text-zinc-500">
          <Link to="/login" data-testid="forgot-back-login" className="text-[#00ffcc] hover:underline">
            Back to sign in
          </Link>
        </p>
      </form>
    </div>
  );
}
